import { render, staticRenderFns } from "./RecruiterStatusRecommended.vue?vue&type=template&id=14a201a8"
import script from "./RecruiterStatusRecommended.vue?vue&type=script&lang=js"
export * from "./RecruiterStatusRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports